function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.037 7.877a6.813 6.813 0 01-2.14-.341c-.335-.114-.746-.01-.95.2l-1.35 1.019C5.032 7.92 4.068 6.956 3.244 5.403l.99-1.314a.97.97 0 00.238-.983A6.824 6.824 0 014.13.963.964.964 0 003.167 0H.963A.964.964 0 000 .963C0 7.049 4.951 12 11.037 12c.531 0 .963-.432.963-.963V8.84a.964.964 0 00-.963-.962z",
  fill: "#0785FE"
});

function SvgTelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _ref);
}

export default SvgTelIcon;